export default __webpack_public_path__ + "static/media/art-blk-banner-3.7c76f0f5.jpg";